<template>
  <div>
    <div v-if="score.score">
      <mdb-btn block v-if="score.score === '채점요'" class="py-0 px-1 m-0 mr-1" color="primary" @click="$emit('view-result')">채점</mdb-btn>
      <mdb-btn block v-else class="p-0 px-1 m-0" :color="color(score.score)" @click="$emit('view-result')">{{score.score}}점</mdb-btn>
    </div>
    <div v-else-if="score.testDate && $isTestDate(score.testDate)">
      <mdb-btn block v-if="test=='태도'" class="p-0 px-1 m-0" color="primary" @click="$emit('view-result')">채점</mdb-btn>
      <span v-else >{{score.etc}}</span>
    </div>
  </div>
</template>
<script>
import {} from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'ScoreView',
  components: { },
  props: ['score', 'test'],
  data: () => ({
    TAG: 'ScoreView'
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training']),
    ...mapGetters('auth', ['isStaff', 'isTeacher']),
    ...mapGetters('training', ['failScore'])
  },
  methods: {
    color (score) {
      if (!this.failScore) return 'success'
      return score < this.failScore ? 'danger' : 'success'
    }
  }
}
</script>
